import { mondayOf } from '@loop3/dates';
function dataOf(r) {
    if (r.error)
        throw new Error(r.error.message);
    return r.data;
}
/** A client's journal between two dates (YYYY-MM-DD), newest week first and entries newest day first; a week with entries but no summary has an empty paragraph and zero counts. */
export async function listClientJournal(db, clientId, opts) {
    const brain = db.schema('brain');
    const [summaries, entries] = await Promise.all([
        brain
            .from('weekly_summaries')
            .select('week_start, paragraph, counts')
            .eq('client_id', clientId)
            .gte('week_start', mondayOf(opts.from))
            .lte('week_start', opts.to)
            .order('week_start', { ascending: false }),
        brain
            .from('journal_entries')
            .select('id, day, sources, title, summary, is_decision, people, links')
            .eq('client_id', clientId)
            .gte('day', opts.from)
            .lte('day', opts.to)
            .order('day', { ascending: false })
            .order('created_at', { ascending: true }),
    ]);
    const weeks = new Map();
    const week = (weekStart) => {
        let w = weeks.get(weekStart);
        if (!w)
            weeks.set(weekStart, (w = { weekStart, paragraph: '', counts: { meetings: 0, slack_threads: 0, decisions: 0 }, entries: [] }));
        return w;
    };
    for (const s of dataOf(summaries) ?? [])
        Object.assign(week(s.week_start), { paragraph: s.paragraph, counts: s.counts });
    for (const e of dataOf(entries) ?? [])
        week(mondayOf(e.day)).entries.push({
            id: e.id, day: e.day, sources: e.sources, title: e.title, summary: e.summary, isDecision: e.is_decision, people: e.people, links: e.links,
        });
    return [...weeks.values()].sort((a, b) => b.weekStart.localeCompare(a.weekStart));
}
